import Head from 'next/head';
import { NextSeo } from 'next-seo';
import ReferralDetails from '@cont/Settings/Referral/ReferralDetails/ReferralDetails';
import Layout from '@layout/FreeLayout/FreeLayout';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import {
  getReferralFeedbackData,
  getReferralShareMessage
} from '@cont/Settings/Referral/ReferralDetails/apiHelper';

const ReferralPage = ({ referralMessage, referralFeedBack }) => {
  const title = 'Referral | Unacademy';

  return (
    <>
      <NextSeo
        title={title}
        openGraph={{
          title
        }}
      />
      <Head>
        <title>Referral | Unacademy</title>
      </Head>
      <ReferralDetails
        referralMessage={referralMessage}
        referralFeedBack={referralFeedBack}
      />
    </>
  );
};

ReferralPage.pageInfo = {
  name: 'Referral Homepage',
  isMWebSupported: true,
  isProtected: true,
  layoutOptions: {
    hideFreshbot: false,
    hideNudges: true,
    showFixedHeader: true
  }
};

export const getStaticProps = async () => {
  const promises = [];
  promises.push(getReferralShareMessage());
  promises.push(getReferralFeedbackData());
  try {
    const [referralMessage, referralFeedBack] = await Promise.all(promises);
    return {
      props: {
        referralMessage: referralMessage?.description,
        referralFeedBack
      },
      revalidate: 60
    };
  } catch (e) {
    return { notFound: true, revalidate: 60 };
  }
};

export default ReferralPage;

ReferralPage.Layout = Layout;
ReferralPage.Wrapper = PageReduxProvider;
